"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOLUTIONS = exports.TAKE_NO_ACTION = exports.REPRINT = exports.REFUND = exports.CANCEL = exports.RESPONSIBLE_PARTIES = exports.CARRIER = exports.FULFILLER = exports.MERCHANT = exports.CUSTOMER = exports.MCP = exports.RESOLVED = exports.REJECTED = exports.OPEN = void 0;
var OPEN = 'open';
exports.OPEN = OPEN;
var REJECTED = 'rejected';
exports.REJECTED = REJECTED;
var RESOLVED = 'resolved';
exports.RESOLVED = RESOLVED;
var MCP = 'mcp';
exports.MCP = MCP;
var CUSTOMER = 'customer';
exports.CUSTOMER = CUSTOMER;
var MERCHANT = 'merchant';
exports.MERCHANT = MERCHANT;
var FULFILLER = 'fulfiller';
exports.FULFILLER = FULFILLER;
var CARRIER = 'carrier';
exports.CARRIER = CARRIER;
var RESPONSIBLE_PARTIES = [MCP, CUSTOMER, MERCHANT, FULFILLER, CARRIER];
exports.RESPONSIBLE_PARTIES = RESPONSIBLE_PARTIES;
var CANCEL = 'cancel';
exports.CANCEL = CANCEL;
var REFUND = 'refund';
exports.REFUND = REFUND;
var REPRINT = 'reprint';
exports.REPRINT = REPRINT;
var TAKE_NO_ACTION = 'takeNoAction';
exports.TAKE_NO_ACTION = TAKE_NO_ACTION;
var RESOLUTIONS = [CANCEL, REFUND, REPRINT, TAKE_NO_ACTION];
exports.RESOLUTIONS = RESOLUTIONS;